const initState = {
  updateLoading: false,
  deleteLoading: false,
  getAllLoading: false,
  driverData: [],
  drivers: [],
  driverRequests: [],
  requestLoading: false,
  orderDetails: null,
  orderDetailsLoading: false,
  orderDetailsError: null,
  driverRestData: null,
  driverAppLink: ""
};
const driverReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ALL_DRIVERS":
      return {
        ...state,
        driverData: action.payload
      };
    case "DRIVER_DETAILS":
      return {
        ...state,
        driverRestData: action.payload
      };
    case "ALL_DRIVER_LOADER":
      return {
        ...state,
        getAllLoading: action.payload
      };
    case "DELETE_DRIVER_LOADER":
      return {
        ...state,
        deleteLoading: action.payload
      };
    case "UPDATE_DRIVER_LOADER":
      return {
        ...state,
        updateLoading: action.payload
      };
    case "DRIVER_UPDATED":
      return {
        ...state,
        driverData: state.driverData.map((driver) =>
          driver.id === action.payload.id
            ? { ...driver, ...action.payload.obj.data.data }
            : driver
        )
      };
    case "DRIVER_DELETED":
      return {
        ...state,
        driverData: state.driverData.filter(
          (driver) => action.payload.id !== driver.id
        )
      };
    case "DRIVER_ADDED":
      return {
        ...state,
        driverData: [action.payload, ...state.driverData]
      };
    case "GET_RESTAURANT_DRIVERS":
      return {
        ...state,
        drivers: action.payload
      };
    case "GET_DRIVER_APP":
      return {
        ...state,
        driverAppLink: action.payload
      };
    case "FETCH_DRIVER_REQUESTS":
      return {
        ...state,
        driverRequests: action.payload
      };
    case "DRIVER_REQUESTS_LOADER":
      return {
        ...state,
        requestLoading: action.payload
      };
    case "FETCH_ORDER_DETAILS_REQUEST":
      return {
        ...state,
        orderDetailsLoading: true,
        orderDetailsError: null,
        orderDetails: null
      };
    case "FETCH_ORDER_DETAILS_SUCCESS":
      return {
        ...state,
        orderDetailsLoading: false,
        orderDetails: action.payload
      };
    case "FETCH_ORDER_DETAILS_FAILURE":
      return {
        ...state,
        orderDetailsLoading: false,
        orderDetailsError: action.payload
      };

    default:
      return {
        ...state
      };
  }
};
export default driverReducer;
